"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _reactSelect = require("react-select");
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Icon = _interopRequireDefault(require("../../../Icon"));
var _MultiSelect = require("../../MultiSelect.utils");
var _react = _interopRequireWildcard(require("react"));
var _multiSelect = require("../../multiSelect.style");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const MultiLevel = _a => {
  var {
      currOption,
      nestedOptions,
      fit,
      expandedList,
      handleGroupHeadingChange,
      handleExpandedList,
      level = 0,
      loadingOptions,
      optionSelected
    } = _a,
    props = __rest(_a, ["currOption", "nestedOptions", "fit", "expandedList", "handleGroupHeadingChange", "handleExpandedList", "level", "loadingOptions", "optionSelected"]);
  const {
    innerProps,
    selectOption
  } = props;
  const {
    allChecked,
    anyChecked
  } = (0, _react.useMemo)(() => (0, _MultiSelect.checkIfSubOptionsChecked)(currOption, optionSelected), [optionSelected]);
  return (0, _jsxRuntime.jsxs)("div", (0, _extends2["default"])({
    className: "nested-optgroup"
  }, {
    children: [(0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
      className: "nested-optgroup-label ".concat(expandedList.includes(currOption.value) ? '' : 'collapsed'),
      style: {
        marginLeft: "".concat(level * 20, "px"),
        width: "calc(93% - ".concat(level * 20, "px)")
      }
    }, {
      children: (0, _jsxRuntime.jsxs)("div", (0, _extends2["default"])({
        className: "nested-optgroup-content"
      }, {
        children: [expandedList.includes(currOption.value) ? (0, _jsxRuntime.jsx)(_Icon["default"], {
          name: 'caret-down',
          onClick: () => handleExpandedList(currOption, false)
        }) : (0, _jsxRuntime.jsx)(_Icon["default"], {
          name: 'caret-up',
          onClick: () => handleExpandedList(currOption, true)
        }), (0, _jsxRuntime.jsx)(_Checkbox["default"], {
          checked: allChecked || anyChecked,
          indeterminate: anyChecked && !allChecked,
          id: currOption.value,
          name: currOption.name,
          disabled: currOption.isDisabled,
          fit: fit,
          onChange: e => handleGroupHeadingChange(e, currOption),
          label: currOption.label
        })]
      }))
    })), loadingOptions.includes(currOption.value) && (0, _jsxRuntime.jsx)(_multiSelect.Components.Loading, {
      label: "loading",
      orientation: "horizontal"
    }), (0, _jsxRuntime.jsx)("div", {
      children: (nestedOptions || []).map(nestedOption => (0, _jsxRuntime.jsx)(_react["default"].Fragment, {
        children: nestedOption.options || nestedOption.hasChildren ? (0, _jsxRuntime.jsx)(MultiLevel, (0, _extends2["default"])({
          currOption: nestedOption,
          nestedOptions: nestedOption.options,
          fit: fit,
          expandedList: expandedList,
          handleGroupHeadingChange: handleGroupHeadingChange,
          handleExpandedList: handleExpandedList,
          level: level + 1,
          loadingOptions: loadingOptions,
          optionSelected: optionSelected
        }, props)) : (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
          className: "nested-optgroup-option",
          style: {
            marginLeft: "".concat((level + 1) * 30, "px")
          }
        }, {
          children: (0, _jsxRuntime.jsx)(_reactSelect.components.Option, (0, _extends2["default"])({}, props, {
            innerProps: (0, _extends2["default"])((0, _extends2["default"])({}, innerProps), {
              onClick: () => selectOption(nestedOption)
            })
          }, {
            children: (0, _jsxRuntime.jsx)(_Checkbox["default"], {
              checked: (props.getValue() || []).map(item => item.value).includes(nestedOption.value),
              id: nestedOption.value,
              name: nestedOption.value,
              disabled: nestedOption.isDisabled,
              fit: fit,
              onChange: () => null,
              label: nestedOption.label
            })
          }))
        }))
      }, nestedOption.value))
    })]
  }));
};
var _default = exports["default"] = MultiLevel;